import { Injectable, computed, signal } from '@angular/core';
import { AppError } from '../models/error';
import { GatewayConfig, GatewayConfigState, INITIAL_GATEWAY_CONFIG_STATE } from './gateway-config.state';

@Injectable({ providedIn: 'root' })
export class GatewayConfigStore {
  readonly #state = signal<GatewayConfigState>(INITIAL_GATEWAY_CONFIG_STATE);

  readonly config = computed(() => this.#state().config);
  readonly loading = computed(() => this.#state().loading);
  readonly error = computed(() => this.#state().error);

  setConfig(config: GatewayConfig): void {
    this.#patch({ config, loading: false, error: null });
  }

  setLoading(loading: boolean): void {
    this.#patch({ loading });
  }

  setError(error: AppError): void {
    this.#patch({ error, loading: false });
  }

  reset(): void {
    this.#state.set(INITIAL_GATEWAY_CONFIG_STATE);
  }

  #patch(partial: Partial<GatewayConfigState>): void {
    this.#state.update(s => ({ ...s, ...partial }));
  }
}
